import React, { useState } from 'react';
import {
    Collapse,
    IconButton,
} from '@chakra-ui/react';
import { AddIcon, MinusIcon } from '@chakra-ui/icons';

const questionsData = [
    {
        question: 'What ages is the application aimed at?',
        answer: 'The application is aimed at children with autism between the ages of 3 and 12.',
    },
    {
        question: 'What skills does the application help develop?',
        answer:
            'The application helps develop non-verbal communication skills, emotion recognition, and social interaction.',
    },
    {
        question: "How does the application work?",
        answer: "The application works through a series of interactive activities that children can complete at their own pace. Activities include AI for game personalization adaptability.",
    },
    {
        question: 'What content does the application have?',
        answer: 'It has games that help children learn basic emotions in a fun and interactive way.',
    },
    {
        question: 'How can I access the application?',
        answer: 'The application is available for download on the App Store and Google Play.',
    },
    {
        question: 'How much does the application cost?',
        answer: 'The application is free to download and use.',
    },
    {
        question: 'What do I need to use the application?',
        answer: 'To use the application, you will need a mobile device with iOS or Android.',
    },
    {
        question:  "How can I get help with the application?"  ,
        answer: "If you need help with the application, you can contact the support team at the email support URL." ,
    },
    {
        question:  "What information is collected about my child?"  ,
        answer: "The application collects information about your child's progress in activities. This information is used to improve your child's learning experience." ,
    },
    {
        question:  "How can I protect my child's privacy?"  ,
        answer: "You can protect your child's privacy by adjusting the privacy settings of the application." ,
    },
    {
        question:  "How can I delete my child's account?"  ,
        answer: "You can delete your child's account at any time by contacting the support team at the email support URL." ,
    },
    {
        question:  "Where can I find more information about the application?"  ,
        answer: "You can find more information about the application on the website:" ,
    },
    {
        question:  "How can I donate to the organization that developed the application?"  ,
        answer: "You can donate to the organization that developed the application on the website: " ,
    },
    {
        question:  "How can I get more information about autism?"  ,
        answer: "You can get more information about autism on the website:" ,
    },
    {
        question:  "How can I find support groups for parents of children with autism?"  ,
        answer: "You can find support groups for parents of children with autism in the WhatsApp group… " ,
    },
    {
        question:  "How can I get help for my child with autism?"  ,
        answer: "You can get help for your child with autism by contacting a mental health professional or autism specialist." ,
    },
];

function QuestionCard({ question, answer, index, openIndex, setOpenIndex }) {
    const isOpen = index === openIndex;

    const handleToggle = () => {
        setOpenIndex(isOpen ? null : index);
    };

    return (
        <div>
            <div className='p-6 rounded-lg' style={{ boxShadow: "0px 5px 16px 0px rgba(8, 15, 52, 0.06)"}}>
                <div className='flex justify-between items-center'>
                    <div className='question text-lg font-bold'>{question}</div>
                    <IconButton
                        size="sm"
                        colorScheme={isOpen ? 'teal' : 'gray'}
                        icon={isOpen ? <MinusIcon/> : <AddIcon/>}
                        onClick={handleToggle}
                    />
                </div>
                <Collapse in={isOpen} animateOpacity>
                    <div className='mt-4 text-base w-full'>
                        {answer}
                    </div>
                </Collapse>
            </div>
        </div>
    );
}

function Questions() {
    const [openIndex, setOpenIndex] = useState(null);

    return (
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {questionsData.map((item, index) => (
                <QuestionCard
                    key={index}
                    question={item.question}
                    answer={item.answer}
                    index={index}
                    openIndex={openIndex}
                    setOpenIndex={setOpenIndex}
                />
            ))}
        </div>
    );
}

export default Questions;
